import React from 'react';
import './aifeedback.scss';
import InlineFeedback from '../inlinefeedback/inlinefeedback';


const AIFeedback = (props) => {

  const handleStartFromTop = () => {
    if (props.actionProvider && props.actionProvider.handleOptions) {
      props.actionProvider.handleOptions();
    }
  };

  // Get conversation ID for the feedback
  const conversationId = props.actionProvider && props.actionProvider.getConversationId ? 
    props.actionProvider.getConversationId() : '';

  return (
    <div className="ai-feedback-container">
      
      <div className="guided-flow-feedback-buttons">
        <button 
          className="top-arrow-button" 
          onClick={handleStartFromTop}
          title="Start from top"
          aria-label="Start from top"
          data-tooltip="Start from top"
        >
        </button>

        <InlineFeedback conversationId={conversationId} />
      </div>
    </div>
  );
};

export default AIFeedback;